import { Model } from '@vuex-orm/core'
import { SigninPayload } from '@/auth/signin/interfaces/payload.interface'
import { setToken } from '@/utils/HttpClient';
import { Constants } from '@/constants';

const API = '/auth'

export default class Auth extends Model {
    static entity = 'auth'
    static fields() {
        return {
            username: this.attr('')
        }
    }

    static async signin(payload: SigninPayload) {
        const result = await this.api().post(Constants.API.AUTH, payload, {
            save: false
        })
        return Promise.resolve(result.response.data)
    }

    static async confirmOtp(payload: SigninPayload) {
        const result = await this.api().post(Constants.API.VERIFY_OTP, payload, {
            save: false
        })
        const token = result.response.data.access_token
        localStorage.setItem('token', token)
        setToken(token)
        return Promise.resolve(result)
    }

    static apiConfig = {
        actions: {
            auth: {
                method: 'get',
                url: API
            },
            signout: {
                method: 'delete',
                url: API
            }
        }
    }
}
